import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const reload = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { setUser(false); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data.user);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } finally { setUser(false); }
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, reload }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
